export default __webpack_public_path__ + "static/media/video-ident-still.abf2243a.jpg";